import { ApiRequest, RequestMethod } from "../../request";

export type EditTeamArguments = {
  teamId: string;
  request: EditTeamRequest;
};

export type EditTeamRequest = {
  name?: string;
  cash?: number;
  reputation?: number;
  description?: string;
  isOutlaw?: boolean;
};

export type ApiMutationResult = {
  success: boolean;
  errorMessage?: string;
};

export async function editTeam({
  teamId,
  request
}: EditTeamArguments): Promise<ApiMutationResult> {
  const URL = `/api/team/${teamId}/edit`;

  const apiRequest = new ApiRequest();

  apiRequest.setMethod(RequestMethod.POST);
  apiRequest.setUrl(URL);

  apiRequest.setJsonBody(request);

  const response: any = await apiRequest.send();

  if (response.status === 200) return { success: true };
  return { success: false, errorMessage: response.data?.errorMessage };
}
